/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import { defineComponent } from 'vue';

// @ts-ignore Není to ESM.
import template from './setup-failure.html';

import CountdownRoot from '../countdown/countdown-root';
import focus from '../focus/focus-directive';

export default defineComponent({
  name: 'SetupFailure',
  template,
  components: { CountdownRoot },
  directives: { focus },
  emits: {
    back() {},
    retry() {}
  },
  methods: {
    onBack() {
      this.$emit('back');
    },
    onEnd() {
      this.retry();
    },
    onRetry() {
      this.retry();
    },
    retry() {
      this.$emit('retry');
    }
  },
  props: {
    message: { type: String, required: true },
    retryTime: { type: Number, required: true }
  }
});
